import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataRefsByKey, ApplianceGroup } from '@shared/models/dataref.model';
import { RecipeLite } from '@shared/models/recipe/recipe-lite.model';

@Component({
  selector: 'app-binaries-management-popin',
  templateUrl: './binaries-management-popin.component.html',
  styleUrls: ['./binaries-management-popin.component.scss'],
  standalone: false,
})
export class BinariesManagementPopinComponent {
  // Input data - see constructor
  recipeOriginal: RecipeLite;
  variants: RecipeLite[];
  applianceGroupsRefData: DataRefsByKey<ApplianceGroup>;
  recipeDirty: boolean;

  // Working variables
  newBinaryHasBeenGenerated$: EventEmitter<void> = new EventEmitter<void>(true);

  constructor(
    @Inject(MAT_DIALOG_DATA)
      data: {
      recipeOriginal: RecipeLite;
      variants: RecipeLite[];
      applianceGroupsRefData: DataRefsByKey<ApplianceGroup>;
      recipeDirty: boolean;
    },
  ) {
    this.recipeOriginal = data.recipeOriginal;
    this.variants = data.variants;
    this.applianceGroupsRefData = data.applianceGroupsRefData;
    this.recipeDirty = data.recipeDirty;
  }
}
